import Phaser from 'phaser';
import dimensions from '../dimensions';
import sounds from '../sounds';

export default class DialogueBox extends Phaser.Group {
    constructor(game, parent, script, callback, effectType) {
        super(game, parent);

        this.script = script;
        this.callback = callback;
        this.effectType = effectType;

        this.direction = script.direction;
        this.speaker = script.speaker;
        this.text = script.text;
        this.init();
    }

    click() {
        if (this.effectOver) {
            this.tile.inputEnabled = false;
            this.frame.inputEnabled = false;
            this.side.inputEnabled = false;

            this.callback();
            this.hide(this.effectType == "exit");
        } else {
            sounds.comms.stop();

            this.effectOver = true;
            this.continue.visible = true;
            this.game.time.events.removeAll();
            this.game.tweens.removeAll();

            for (let i = 0; i < this.text.children.length; i++) {
                this.text.children[i].visible = true;
            }
        }
    }

    show(showEffect) {
        this.continue.visible = false;

        let timing = 0;

        if (showEffect) {
            timing = 350;
            this.alpha = 0;
        }

        sounds.comms.play();

        for (let i = 0; i < this.text.children.length; i++) {
            this.text.children[i].visible = false;

            this.game.time.events.add(timing + i * 30, function (i) {
                this.text.children[i].visible = true;
            }.bind(this, i));
        }

        this.game.time.events.add(timing + this.text.children.length * 30, function () {
            this.continue.visible = true;
            this.effectOver = true;
            sounds.comms.stop();
        }.bind(this));

        if (showEffect) this.game.add.tween(this).to({ alpha: 1 }, timing, "Linear", true);
    }

    hide(showEffect) {
        if (showEffect) {
            this.game.add.tween(this).to({ alpha: 0 }, 350, "Linear", true).onComplete.add(function () {
                this.destroy();
            }.bind(this));
        } else {
            this.destroy();
        }
    }

    init() {
        this.tile = this.game.add.tileSprite(dimensions.gameWidth / 2, dimensions.actualHeight, dimensions.actualWidth - 527, 255, "sheet", "msg-tiled");
        this.tile.anchor.set(0.5, 1);
        this.add(this.tile);

        this.frame = this.game.add.sprite((dimensions.gameWidth - dimensions.actualWidth) / 2, dimensions.actualHeight, "sheet", "msg-frame");
        this.frame.anchor.set(0, 1);
        this.add(this.frame);

        this.side = this.game.add.sprite(dimensions.gameWidth + (dimensions.actualWidth - dimensions.gameWidth) / 2, dimensions.actualHeight, "sheet", "msg-side");
        this.side.anchor.set(1, 1);
        this.add(this.side);

        this.character = this.game.add.sprite(this.frame.width / 2, -this.frame.height / 2 - 5, "sheet", this.speaker.replace(" ", "_"));
        this.character.anchor.set(0.5);
        this.character.scale.set(0.8);
        this.frame.addChild(this.character);

        this.name = this.game.add.bitmapText(dimensions.gameWidth / 2 + this.frame.width / 2, dimensions.actualHeight - 210, "font-title", this.speaker, 40);
        this.name.anchor.set(0.5);
        this.add(this.name);

        this.text = this.game.add.bitmapText(this.frame.x + this.frame.width + 50, this.frame.y - 170, "font-text", this.text, 23);
        this.text.maxWidth = this.tile.width + this.side.width - 100;
        this.add(this.text);

        this.continue = this.game.add.bitmapText(this.side.x - 200, this.frame.y - 30, "font-text", "Click to continue...", 20);
        this.add(this.continue);

        if (this.direction == "right") {
            this.frame.x = dimensions.gameWidth + (dimensions.actualWidth - dimensions.gameWidth) / 2;
            this.frame.scale.set(-1, 1);

            this.side.x = (dimensions.gameWidth - dimensions.actualWidth) / 2;
            this.side.scale.set(-1, 1);

            this.text.x += this.frame.width;
            this.name.x += this.frame.width;
            this.continue.x += this.frame.width;
        }

        this.tile.inputEnabled = true;
        this.frame.inputEnabled = true;
        this.side.inputEnabled = true;
        this.tile.events.onInputUp.add(this.click.bind(this));
        this.frame.events.onInputUp.add(this.click.bind(this));
        this.side.events.onInputUp.add(this.click.bind(this));

        this.show(this.effectType == "entry");
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/objects/DialogueBox.js
// module id = 71
// module chunks = 0